import React from 'react';
import './CatalogoEmpresasIntegras.css';

const CatalogoEmpresasIntegras = () => {

  const abrirEnNuevaPestana = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="catalogo-empresas-integras">
      <div className="catalogo-contenido">

        <h1>Catálogo de Empresas Íntegras</h1>

        <img
          src="/assets/imgs/EmpresasIntegrasHidalgo/empresas-integras.png"
          alt="Empresas Íntegras Hidalgo"
          className="catalogo-logo"
        />

        <div className="catalogo-botones">

        <button
            className="btn-catalogo btn-catalogo-principal"
            // onClick={() =>
            //     abrirEnNuevaPestana(
            //     'https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/0010'
            //     )
            // }
            >
            Catálogo de Empresas Íntegras
            </button>

          <button
            className="btn-catalogo"
            onClick={() =>
              abrirEnNuevaPestana(
            'https://esit.hidalgo.gob.mx/eSIT/oficinaVirtual/P1_mov_padron/oficina_virtual/c_oficina_virtual_ss.jsp?cve_ruts=SC/SC/0010'
              )
            }
          >
            Ir al Servicio
          </button>

          <button
            className="btn-catalogo"
            onClick={() =>
              abrirEnNuevaPestana(
                'https://ruts20.hidalgo.gob.mx/informacion/13995'
              )
            }
          >
            Requisitos
          </button>

          <button
              className="btn-catalogo btn-video"
              onClick={() =>
                abrirEnNuevaPestana(
                  '/assets/imgs/VIDEO TUTORIAL OFICINA VIRTUAL DE EMPRESAS INTEGRAS.mp4'
                )
              }
            >
              Video Tutorial
            </button>

        </div>

        <p className="catalogo-contacto">
          Para cualquier consulta, ponemos a su disposición los siguientes
          medios de contacto en horario laboral, de 9:00 a.m. a 5:00 p.m.
        </p>

      </div>
    </div>
  );
};

export default CatalogoEmpresasIntegras;